import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft, ShieldAlert } from 'lucide-react';
import { motion } from 'framer-motion';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-6 relative overflow-hidden font-sans">
      {/* Background gradients */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-indigo-500/20 rounded-full blur-[100px] animate-pulse"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-emerald-500/10 rounded-full blur-[100px] animate-pulse delay-700"></div>

      <div className="relative max-w-md w-full bg-white/5 backdrop-blur-xl border border-white/10 rounded-3xl p-8 text-center shadow-2xl">
        <div className="w-20 h-20 bg-rose-500/20 text-rose-400 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-rose-500/30">
          <ShieldAlert className="w-10 h-10 animate-bounce" />
        </div>

        <h1 className="text-8xl font-black text-white tracking-wider mb-2 select-none bg-gradient-to-r from-indigo-400 via-rose-400 to-emerald-400 bg-clip-text text-transparent">
          404
        </h1>
        <h2 className="text-xl font-bold text-slate-100 mb-3">
          Page Not Found
        </h2>
        <p className="text-slate-400 text-sm mb-8 leading-relaxed">
          The page you are looking for doesn't exist, has been moved, or you might not have permission to view it.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 items-center justify-center">
          <button 
            onClick={() => window.history.back()}
            className="w-full sm:w-auto px-5 py-3 bg-white/10 hover:bg-white/15 text-slate-200 hover:text-white rounded-xl text-sm font-bold transition-all border border-white/10 flex items-center justify-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
          
          <Link 
            to="/" 
            className="w-full sm:w-auto px-5 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-xl text-sm font-bold transition-all shadow-lg shadow-indigo-950/50 flex items-center justify-center gap-2"
          >
            <Home className="w-4 h-4" />
            Go Home
          </Link>
        </div>
      </div>
    </div>
  );
}
